import {
    Component,
    Renderer2
} from '@angular/core';

// core services
import { RendererService } from '../../../core/services/rendererService';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html'
})
export class AppComponent {
    constructor(
        private _rendererService: RendererService,
        private _renderer2: Renderer2
    ) {
        _rendererService.renderer2 = _renderer2;
    }
}



// WEBPACK FOOTER //
// ./client-src/app/eStore/components/app/app.component.ts